<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                    type="text"
                    name="name"
                    label="جستجو"
                    validation-container-class="col-lg-3"
                    input-class="form-control"
                    v-model.lazy="filters.search"
                    @keyup.enter="loadData()"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                      class="margin-top margin-right btn btn-warning"
                      @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
              ref="grid"
              :columns="gridColumns"
              :read-data="readData"
              :grid-server-side="true"
              :schema-total="'total'"
              :schema-data="'data'"
              :server-paging="true"
              :batch="true"
              :page-size="pageSize"
              :current-page="currentPage"
              :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
    <commission-payment-form ref="commissionPaymentModal"></commission-payment-form>
  </div>
</template>
<script>
import CommissionPaymentForm from "./components/CommissionPaymentForm";

import { designerApi } from "@/api/apiManagement.js";
export default {
  components: {
    CommissionPaymentForm,
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت طراحان",
          link: "/shop/designers",
          active: true,
        },
      ],
      filters: {},
      isLoadingGrid: false,
      isLoadingModal: false,

      gridColumns: [
        { field: "name", title: "نام" },
        { field: "family", title: "نام خانوادگی" },
        {
          field: "sum_commission",
          title: "مجموع درآمد",
          template: (e) => (e.sum_commission ? this.$thousandSeprator(e.sum_commission) : "-"),
        },
        {
          field: "sum_commission",
          title: "مانده طلب",
          template: (e) => {
            let sum_c = e.sum_commission ?? 0;
            let sum_p = e.sum_payments ?? 0;
            let remain = sum_c - sum_p;
            return remain ? this.$thousandSeprator(remain): '-';
          },
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
    };
  },

  mounted() {
    if (this.$route.query) this.filters = this.$route.query;
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    resetFilters() {
      this.filters = {};
      this.$refs.filterForm.reset();
      let selects = Object.values(this.$refs);
      selects.forEach((el) => {
        if (el && el.emptyKendo) el.emptyKendo();
      });
      this.loadData()
    },
    readData(e) {
      this.$resetGrid();
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;

      designerApi
          .get({
            page_size: this.pageSize,
            page: this.currentPage,
            ...this.filters,
          })
          .then(({data}) => {
            e.success(data.entity);
          })
          .catch(() => {
            e.success([]);
          })
          .finally(() => {
            this.isLoadingGrid = false;
          });
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },

    gridCommands() {
      let commands = [];

      commands.push({
        text: "orders",
        click: this.orders,
        template: this.gridButtons.orders,
      });
      // commands.push({
      //   text: "view",
      //   click: this.deposits,
      //   template: this.gridButtons.view,
      // });
      commands.push({
        text: "prices",
        click: this.getCommissionPayments,
        template: this.gridButtons.prices,
      });

      return commands;
    },
    getCommissionPayments(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.commissionPaymentModal.init(data);
    },
    orders(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$router.push({ path: `/shop/designers/${data.id}/orders` });
    },
    deposits(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$router.push({ path: `/shop/designers/${data.id}/deposits` });
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
.badge {
  margin: 2px;
  font-size: 13px !important;
  font-weight: 800;
}
</style>
